import { useEffect } from 'react';

function useKeyPressWithCallback(targetKey, cb) {
  if (cb === void 0) {
    cb = function cb() {
      return void 0;
    };
  }

  useEffect(function () {
    function downHandler(_ref) {
      var key = _ref.key;

      if (key === targetKey) {
        cb();
      }
    }

    window.addEventListener("keydown", downHandler);
    return function () {
      window.removeEventListener("keydown", downHandler);
    };
  }, [cb, targetKey]);
}

export { useKeyPressWithCallback };